import React, { useState, useContext, useEffect } from "react";
import { Page } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { TitleBar, ContextualSaveBar } from "@shopify/app-bridge-react";
import TagsForm from "./Form";
import { useParams } from "react-router-dom";
import { AppContext } from "../../../../components/global/appContext";
import { Navigate } from "react-router-dom";
import {
  useGetTag,
  useUpdateTag,
  useDeleteTag,
} from "../../../../hooks/queries/tags";
import TagsFormSkeleton from "./SkeletonForm";

export default function TagsEdit(props) {
  const { t } = useTranslation();
  const appContext = useContext(AppContext);
  let { id } = useParams();

  const [tag, setTag] = useState(null);
  const [errors, setErrors] = useState(null);
  const [tagDeleted, setTagDeleted] = useState(false);

  const { data, isError } = useGetTag(id);
  useEffect(() => {
    if (data) setTag(data);
  }, [data]);
  const hasUnsavedChanges = JSON.stringify(data) !== JSON.stringify(tag);

  const updateTagMutation = useUpdateTag(id, {
    onSuccess: (data) => {
      setErrors(null);
      setTag(data);
      appContext.setMessage(t("settings.tags.messages.savedSuccessfully"));
    },
    onError: (error) => {
      setErrors(error.response.data);
      appContext.setMessage(t("settings.tags.messages.couldntSave"), true);
    },
  });

  const deleteTagMutation = useDeleteTag(id, {
    onSuccess: () => {
      setTagDeleted(true);
      appContext.setMessage(t("settings.tags.messages.tagDeleted"));
    },
  });

  if (tagDeleted) return <Navigate to="/settings/tags" />;
  if (isError) return <p>{t("settings.tags.error")}</p>;
  if (tag)
    return (
      <Page>
        <TitleBar
          title={tag ? tag.title : "Tag"}
          breadcrumbs={[{ content: t("settings.tags.title"), url: "/settings/tags" }]}
        />
        <ContextualSaveBar
          saveAction={{
            content: t("settings.tags.actions.save"),
            onAction: () => updateTagMutation.mutate(tag),
            loading: updateTagMutation.isLoading,
          }}
          discardAction={{
            onAction: () => setTag(data),
          }}
          fullWidth
          visible={hasUnsavedChanges}
        />
        <TagsForm
          tag={tag}
          setTag={setTag}
          errors={errors}
          secondaryActions={[
            {
              content: t("settings.tags.actions.deleteTag"),
              destructive: true,
              outline: true,
              loading: deleteTagMutation.isLoading,
              onAction: deleteTagMutation.mutate,
            },
          ]}
        />
      </Page>
    );
  return (
    <Page>
      <TitleBar
        title={" "}
        breadcrumbs={[{ content: t("settings.tags.title"), url: "/settings/tags" }]}
      />
      <TagsFormSkeleton
        secondaryActions={[
          {
            content: t("settings.tags.actions.deleteTag"),
            destructive: true,
            outline: true,
            loading: true,
          },
        ]}
      />
    </Page>
  );
}
